import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

import { reactive, getCurrentInstance,ref } from 'vue'
import Keys from '@/constant/key'
import { useStore } from '@/store/index'
import { joinParams } from '@/utils'
import { getCityListApi } from '@/apis/others'

export default /*@__PURE__*/_defineComponent({
  __name: 'BaoPinData',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const store = useStore()
const filterData = reactive({
    city_id: '',
    from: '',
    to: '',
    shop_discount_start: '',
    shop_discount_end: '',
    type: '',
});
const list = ref<any[]>([])
const onGetList = async () => {
    const {code, data, msg} = await getCityListApi() as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    list.value = data
}
onGetList()
const onExport = () => {
    if (!filterData.type) {
        proxy.$message({ type: 'warning', message: '请选择导表类型' })
        return
    }
    
    const params = {
        ...filterData,
        user_id: store.state.user.userInfo.id
    }
    
    window.open(`${Keys.baseUrl}/sys/admin/hot?${joinParams(params)}&is_export=1`)
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, {
    class: "mb15",
    shadow: "hover"
  }, {
    header: _withCtx(() => _cache[6] || (_cache[6] = [
      _createElementVNode("div", {
        class: "card-header",
        style: {"font-size":"14px","font-weight":"bold"}
      }, [
        _createElementVNode("span", null, "爆品数据")
      ], -1)
    ])),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        inline: true,
        class: "filter-form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "城市：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: filterData.city_id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterData.city_id) = $event)),
                placeholder: "全部",
                class: "filter-item select-item",
                filterable: "",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "开始时间：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: filterData.from,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterData.from) = $event)),
                type: "date",
                placeholder: "选择开始日期",
                class: "filter-item date-input",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "结束时间：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: filterData.to,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterData.to) = $event)),
                type: "date",
                placeholder: "选择结束日期",
                class: "filter-item date-input",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "折扣起始：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: filterData.shop_discount_start,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filterData.shop_discount_start) = $event)),
                placeholder: "输入折扣起始",
                class: "filter-item input-item"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "折扣结束：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: filterData.shop_discount_end,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filterData.shop_discount_end) = $event)),
                placeholder: "输入折扣结束",
                class: "filter-item input-item"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "导表类型：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: filterData.type,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filterData.type) = $event)),
                placeholder: "请选择",
                class: "filter-item select-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "商品",
                    value: "1"
                  }),
                  _createVNode(_component_el_option, {
                    label: "订单",
                    value: "2"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: onExport,
                class: "export-btn"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("导出")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})